import { Box, Icon, Prose, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  summary: string
}

export function MeetingSummary({ summary }: Props) {
  return (
    <Box alignItems="flexStart" gap="s16">
      <Box
        inline
        background="purple200"
        borderRadius={{ all: 'abs010' }}
        paddingX="s8"
        paddingY="s4"
        height="s32"
        flexDirection="row"
        alignItems="center"
      >
        <Icon.Medium icon="ai" color="grey800" />
        <Text.Normal size="200" weight="semibold">
          {i18n.t('one_on_ones.meeting.summary.title')}
        </Text.Normal>
      </Box>
      <Box
        border={{ all: { color: 'purple200', width: 's2', style: 'solid' } }}
        borderRadius={{ all: 'abs010' }}
        padding="s16"
        width="full"
      >
        <Prose fullWidth>{summary}</Prose>
      </Box>
    </Box>
  )
}
